
export const ROUTES = {
    Home: '/',
    About: '#about',
    Overview: '#overview',
    Work: '#work',
    OneWork: '/:id',
    OneBlog: '/blog/:id',
    Contact: '#contact'
}